import { render, staticRenderFns } from "./ViewIcon2.vue?vue&type=template&id=658bf9da"
import script from "./ViewIcon2.vue?vue&type=script&lang=js"
export * from "./ViewIcon2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports